import httpClient from "@/services/httpClient";
import { server, trademark_const } from "@/services/constants";

export const getAllFileAtLaw = () => {
    return httpClient.get(server.API_FILE_ATTACH_AT_LAW);
};

export const getAllFileAtLawByID = (tbl_id) => {
    return httpClient.get(server.API_FILE_ATTACH_AT_LAW + `/${tbl_id}`);
};

export const getAllFileAtLawFile = (query) => {
    return httpClient.get(server.API_FILE_ATTACH_AT_LAW + `/data-file`, query);
};
export const getAllFileAtLawFileAp = (query) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.API_FILE_ATTACH_AT_LAW + `/data-file-ap`, query);
}

export const DeletFileAtLawFileID = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.API_FILE_ATTACH_AT_LAW + `/by-id`, data);
};
export const deleteByTrademarkID = (data) => {
    return httpClient.post(server.API_FILE_ATTACH_AT_LAW + `/by-tm-id`, data);
};
export const ip_deleteByTrademarkID = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.API_FILE_ATTACH_AT_LAW + `/by-tm-id`, data);
};

// export const getDoctypeByID = (doctype_id) => {
//     return httpClient.get(server.DOCTYPE + `/bydoctype_id/${doctype_id}`);
// };
// export const getDoctypeByDepID = (dep_id) => {
//     return httpClient.get(server.DOCTYPE + `/bydoctype-depid/${dep_id}`);
// };
// export const getCheckDoctype = (doctype) => {
//     return httpClient.get(server.DOCTYPE + `/bydoctype/${doctype}`);
// };

// export const createDoctype = (data) => {
//     return httpClient.post(server.DOCTYPE,data);
// };

// export const UpdateFileDoctype = (id,data) => {
//     return httpClient.post(server.DOCTYPE +`/updatefile/${id}`,data);
// };
// export const UpdateDoctype = (id, data) => {
//     return httpClient.put(server.DOCTYPE +`/${id}`,data);
// };

